import TakebackCategoryBannerCard from './takeback-category-banner-card'
import TakebackCheckoutCard from './takeback-checkout-card'
import { useResponsive } from 'packages/microsite-components/src/hooks'

type Props = {
  categoryId?: string | undefined
}

export default function TakebackWrapper({ categoryId }: Props) {
  const { breakpoints } = useResponsive()

  if (categoryId) {
    return <TakebackCategoryBannerCard breakpoints={breakpoints} />
  }

  return <TakebackCheckoutCard breakpoints={breakpoints} />
}
